import { render, staticRenderFns } from "./PointPurchase.vue?vue&type=template&id=4a0e7ae0"
import script from "./PointPurchase.vue?vue&type=script&lang=js"
export * from "./PointPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports